import * as React from "react";
import { NGButton } from "../../../newcomponents/button/Button";
import { useFormContext } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { DomainInput } from "./types/input";
import { Domain } from "../../../schema/types/domain/entity";
import { domainToInput, getDefaultDomainInput, inputToDomain } from "./utils/utils";
import { isEqual } from "lodash";

interface Props {
  domain?: Domain;
}
export const CreateNGCancelReset: React.FC<Props> = ({ domain }) => {
  const navigate = useNavigate();
  const { watch } = useFormContext<DomainInput>();

  const allValues = watch();
  const lastPath = watch(`lastPath`);
  const isEdit = watch("isEdit");

  const isDirty = React.useMemo(() => {
    if (!isEdit) {
      return true;
    }

    const initialInput = domain ? domainToInput(domain) : getDefaultDomainInput();
    const initialBody = inputToDomain(initialInput);
    const currentBody = inputToDomain(allValues);

    return !isEqual(initialBody, currentBody);
  }, [isEdit, allValues]);

  return (
    <NGButton variant="danger" outlined className="w-full" type={`button`} onClick={() => navigate(lastPath)}>
      {isEdit ? (isDirty ? "Cancel" : "Back") : "Cancel"}
    </NGButton>
  );
};
